module.exports = {
  "country": "IS",
  "artist": "Selma",
  "song": "All Out of Luck",
  "year": "1999",
  "place": "2",
  "spotify": "64IYu4fSSoR5XzgzhdYsot"
};